module.exports = __webpack_public_path__ + "media/logos/expo_cuu_bco-a1e1f90e.png";